// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RestoreOutlinedSvg from "@fishx/icons-svg/es/asn/RestoreOutlined";
import FishxIcon from '../components/FishxIcon';

var RestoreOutlined = function RestoreOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: RestoreOutlinedSvg
  }));
};

RestoreOutlined.displayName = 'RestoreOutlined';
export default React.forwardRef(RestoreOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/RestoreOutlined.js
// module id = 4005
// module chunks = 0